module.exports = __webpack_public_path__ + "img/step1.8f11787a.svg";